import {Inject, Injectable} from '@angular/core';
import {ReducedDeviceLocationDto} from "../models/device/reduced-device-location-dto";
import {Observable} from "rxjs";
import {ServerEndpoints} from "../server.endpoints";
import {HttpClient, HttpHeaders} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class DeviceHttpService {

  constructor(@Inject("BASE_URL") private baseUrl: string,
              private http: HttpClient,
              @Inject('BASE_HEADERS') baseHeaders: HttpHeaders) {
  }

  dictReducedDeviceLocation(shardId: string): Observable<{ [id: string]: ReducedDeviceLocationDto[] }> {
    return this.http.get<{
      [id: string]: ReducedDeviceLocationDto[]
    }>(this.baseUrl + ServerEndpoints.Management_Device_Location + "?shardId=" + shardId);
  }


}
